import { SubmitHandler, useForm } from 'react-hook-form';
import { ImCheckmark} from 'react-icons/im'
import { FiAlertCircle} from 'react-icons/fi'
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { refreshtoken, resetStatus, updatePassword } from '../../../store/user';
import Message from '../../../components/message';
import { useEffect } from 'react';
import Tooltipaction from '../../../components/Tooltip/tooltipAction';
import { RiErrorWarningLine } from 'react-icons/ri';
type FormValues = {
  password_old: string
  password_new: string
  password_re_new:string
};
const Passwordprofile = () => {
  const  QA = process.env.REACT_APP_QA
  const dispatch=useAppDispatch()
  const {status, email} = useAppSelector(state =>state.user)
  const { register, handleSubmit, formState: { errors }, watch, reset} = useForm<FormValues>();
  const con_pass = watch("password_new")
  const pass_odl = watch("password_old")
  const pass_re_new = watch("password_re_new")
  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    await dispatch(updatePassword(data))
/*     await dispatch(refreshtoken()) */
  };



  useEffect(() => {
    if (status === 'updatePassword_success' || status === 'updatePassword_rejected'){
      reset()
    }
  }, [status])
  return (
    <div className="c-profile">
      <div className="c-profile__header">
        <span className="c-profile__title">My Password</span>
      </div>
      <form className="c-profile__body" onSubmit={handleSubmit(onSubmit)}>
        <span className="c-profile__text-title">Email Address</span>
        <span className="c-profile__text-data">{email}</span>
        <hr className="c-profile__line"/>
        <div className="c-profile__item-box">
          <div className="c-profile__colum">
            <div className="c-profile__container-input">
              <div className="c-input__header">
                <span className="c-input__title">Current Password</span>
              </div>
              <label  className="c-profile__box-input">
                <input type="password" className="c-profile__input-password"
                  {...register("password_old", {
                    required: "old password is required"
                  })}
                />
                <span className={`c-profile__icon-input-password ${errors.password_old && `c-profile__icon-input-password--alert`}`}>
                  {
                    errors.password_old ? <FiAlertCircle /> : pass_odl?.length > 3 && <ImCheckmark />
                  }
                </span>
              </label>
              {
                errors.password_old ?
                  <label className="c-profile__text-alert">
                    {errors.password_old?.message}
                  </label>
                  : null
              }
            </div>
          </div>
        </div>
        <div className="c-profile__item-box">
          <div className="c-profile__colum">
            <div className="c-profile__container-input">
              <div className="c-input__header">
                <span className="c-input__title">New Password</span>
                {
                  QA === 'true' &&
                  <Tooltipaction
                    placement="top"
                    text="The password must contain at least 6 characters and one special character e.g. !@#$%ˆ&*."
                    margin={5}
                  >
                    <div className="c-input__icon"><RiErrorWarningLine/></div>
                  </Tooltipaction>
                }
              </div>
              <label className="c-profile__box-input">
                <input type="password" className="c-profile__input-password"
                  {...register("password_new", {
                    required: "new password is required",
                    minLength: {
                      value: 8,
                      message: "Password must have at least 8 characters"
                    }
                  })}
                />
                <span className={`c-profile__icon-input-password ${errors.password_new && `c-profile__icon-input-password--alert`}`}>
                  {
                   !errors.password_new && con_pass?.length > 3 && con_pass === pass_re_new ? <ImCheckmark /> : null
                  }
                  {
                    errors.password_new && <FiAlertCircle/> 
                  }
                </span>
              </label>
              {
                errors.password_new ?
                  <label className="c-profile__text-alert">
                    {errors.password_new?.message}
                  </label>
                  : null
              }
            </div>
          </div>
          <div className="c-profile__colum">
            <div className="c-profile__container-input">
              <div className="c-input__header">
                <span className="c-input__title">Confirm New Password</span>
              </div>
              <label className="c-profile__box-input">
                <input type="password" className="c-profile__input-password"
                  {...register("password_re_new", {
                    validate: value => value === con_pass || "The password and its confirm are not the same"
                  })}
                />
                <span className={`c-profile__icon-input-password ${errors.password_re_new && `c-profile__icon-input-password--alert`}`}>
                  {
                    !errors.password_re_new && pass_re_new?.length > 3 && con_pass === pass_re_new ? <ImCheckmark /> : null
                  }
                  {
                    errors.password_re_new && <FiAlertCircle/> 
                  }
                </span>
              </label>
              {
                errors.password_re_new ?
                  <label className="c-profile__text-alert">
                    {errors.password_re_new?.message}
                  </label>
                  : null
              }
            </div>
          </div>
        </div>
        <span className="c-profile__description">
          Password must be at least 8 character and contain symbols
        </span>

        {
          status === 'updatePassword_success' && <Message type="success" message="Your password was updated correctly" clouse={() => dispatch(resetStatus())}/>
        }

        {
          status === 'updatePassword_rejected' && <Message type="error" message="There was an error trying to update your password, try again" clouse={() => dispatch(resetStatus())} />
        }

        <div className="c-profile__footer-password">
          <button type="submit" className={`c-profile__save-changues ${status === 'updatePassword_loading' && `c-profile__save-changues--disabled`}`}>
            {
              status === 'updatePassword_loading' ? <><div className="spiner"></div> loading...</>
                :
                <>
                  Update Password
                </>

            }
          </button>

          <button type="button" className={`c-profile__save-changues c-profile__save-changues--cancel`}>
            cancel
          </button>
        </div>
      </form>
    </div>
  )
}

export default Passwordprofile